module.exports = __webpack_public_path__ + "static/media/segoe-ui-webfont.da122ffd.woff";